<template>
    <div class="container">
        <!-- 滑动文字区域 -->
        <div class="scrollable-text">
            <div v-if="platform !== 'Android'">
                
            
            <p>
                App Store中【5星好评】+【15字以上评论】，截图发送给客服，即可领取3天会员。！
            </p>
            <!-- <h4 class="single-text">
                <p>按以下步骤找到好评截图，一个账号只能参加一次。</p>
            </h4>
            <h4>步骤1</h4>
            <img src="@/assets/set1.jpg" alt="" />
            <h4><br>步骤2</h4>
            <img src="@/assets/set2.jpg" alt="" />
            <h4><br>步骤3</h4>
            <img src="@/assets/set3.jpg" alt="" />
            <h4><br>步骤4(只需要以下页面的截图即可):</h4>
            <img src="@/assets/set4.jpg" alt="" /> -->
        </div>
        <div v-else>
            <p>
                1.前往应用商店5星好评+10字以上评论<br>
2.截图+手机号发送给在线客服即可领取3天会员
            </p>
            <h4 class="single-text">
                <p>一个账号只能参加一次。</p>
            </h4>
        </div>
    </div>

        <div class="fixed-button" v-if="platform !== 'Android'">
            <el-row>
                <el-col :span="12">
                    <div>
                        <button class="custom-button" @click="jumpAppStore" style="width: 100%;height: 50px;">去好评</button>
                    </div>
                </el-col>
                <el-col :span="12">
                    <div>
                        <button class="custom-button" @click="copyContact"
                            style="width: 100%;height: 50px; margin-left: 10px;">联系客服</button>
                    </div>
                </el-col>
            </el-row>
        </div>
        <div class="fixed-button" v-else>
            <el-row>
                <el-col :span="24">
                    <div>
                        <button class="custom-button" @click="copyContact"
                            style="width: 100%;height: 50px;">联系客服</button>
                    </div>
                </el-col>
            </el-row>
        </div>

    </div>
</template>

<script>
import { ElMessage } from 'element-plus';
export default {
    data() {
        return {
            platform: '',
        };
    },
    created() {
        document.title = "好评有礼";
        this.platform = this.judgeClient();
    },
    methods: {
        jumpAppStore() {
            if (window.webkit && window.webkit.messageHandlers) {

                // 在 Vue 中调用 iOS WebView 的 getToken 方法
                window.webkit.messageHandlers.IosFound.postMessage("jumpAppStore");


            } else {
                
                ElMessage.error("暂不支持除IOS 以外平台");
            }
        },
        copyContact() {
            // const contactNumber = "1971715546";
            // const textArea = document.createElement("textarea");
            // textArea.value = contactNumber;
            // document.body.appendChild(textArea);
            // textArea.select();
            // document.execCommand("Copy");
            // document.body.removeChild(textArea);
            // ElMessage.success("复制成功")
            if(this.platform == "Android"){
                window.android.jumpWxServe("")
            }else{

           
             if (window.webkit && window.webkit.messageHandlers) {
               
                // 在 Vue 中调用 iOS WebView 的 getToken 方法
                window.webkit.messageHandlers.IosFound.postMessage("jumpWxServe");


            } else {
                ElMessage.error("暂不支持除IOS 以外平台");
            }
        }

        },
         // 检查客户端
    judgeClient() {
      let u = navigator.userAgent;
    
      let isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1;   //判断是否是 android终端
      let isIOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/);     //判断是否是 iOS终端
      console.log('是否是Android：' + isAndroid); //true,false
      console.log('是否是iOS：' + isIOS);
      if (isAndroid) {
        return 'Android';
      } else if (isIOS) {
        return 'IOS';
      } else {
        return 'PC';
      }
    },
    },

}
</script>
<style scoped>
.container {
    display: flex;
    flex-direction: column;
    min-height: 100vh;
    margin: 0;
    /* 添加这一行 */
}

.scrollable-text {
    flex-grow: 1;
    overflow-y: auto;
    padding: 20px;
    margin: 0;
    /* 添加这一行 */
}

.scrollable-text p {
    text-align: left;
    margin: 0;
}

.single-text p {
    color: red;
}
a {
    text-decoration: none;
  }
img {
    max-width: 100%;
    height: auto;
    padding: 10px;
}

.custom-button {
    border: none;
    border-radius: 50px;
    background-color: #ff0000;
    /* 红色背景 */
    color: #fff;
    /* 文字颜色，可以根据需要调整 */
    padding: 10px 20px;
    /* 根据需要调整按钮内边距 */
    font-size: 16px;
    /* 根据需要调整文字大小 */
    cursor: pointer;
    /* 可以根据需要添加其他样式，比如悬浮效果等 */
}

.fixed-button {
    width: 90%;
    height: 50px;

    color: #fff;
    margin-bottom: 20px;
    border: none;
    border-radius: 25px;
    font-size: 16px;
    cursor: pointer;
    position: fixed;
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
}</style>
